// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Planificador de OPU (decisión 0085 · Q-251): previsión Bayesiana + preselección.

export const planningPaths = {
    opuPlan: () => 'admin/reproduction/planning',
};
